import { useState, useEffect } from 'react'
import gql from '../utils/graphql'
import { readDoctorRequisition } from '../graphql/queries'
import { get, filter } from 'lodash'

const useResultNotifications = (sessionId, oktaId, status, testType) => {
  const [requisitions, setRequisitions] = useState([])
  const [shouldUpdate, setShouldUpdate] = useState(false)

  const refresh = () => {
    setShouldUpdate(!shouldUpdate)
  }

  useEffect(() => {
    const fetchRequisitions = async () => {
      try {
        const res = get(
          await gql({
            operation: readDoctorRequisition,
            path: 'readDoctorRequisition',
            variables: {
              sessionId,
              oktaId,
              status
            }
          }),
          'body.doctorRequisitions'
        )
        if (!testType) return setRequisitions(res)
        return setRequisitions(
          filter(res, requisition => get(requisition, 'test.type') === testType)
        )
      } catch (e) {
        console.error(e)
      }
    }

    if (sessionId && oktaId) fetchRequisitions()
  }, [sessionId, oktaId, status, shouldUpdate, testType])

  return [requisitions.length, refresh]
}

export default useResultNotifications
